import { create } from 'zustand';

interface ProjectsScreenState {
  open: boolean;
  openScreen: () => void;
  close: () => void;
}

/** Controls the full-screen Projects view (overlay over the canvas). */
export const useProjectsScreen = create<ProjectsScreenState>((set) => ({
  open: false,
  openScreen: () => set({ open: true }),
  close: () => set({ open: false }),
}));
